/**
 * Module « dashboards » — DASH-01 à DASH-04.
 *
 * Quatre vues (SPEC-FONCTIONNELLE §13) : remplissage par représentation,
 * avancement de la campagne, revenus encaissés et dus, et renvoi vers les
 * impayés. Rôle minimal : lecture.
 *
 * ★ Et, depuis le retour client du 22 août, un SECOND écran : la fiche d'une
 * soirée. Le détail vivait sous la liste ; il a désormais une adresse, donc il
 * se partage et il survit à un rechargement. Le raisonnement complet est en
 * tête de `PageRepresentation.tsx`.
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

import { SEGMENT_REPRESENTATION } from './chemins'

const TableauxDeBord = lazy(() => import('./TableauxDeBord').then((m) => ({ default: m.TableauxDeBord })))
const PageRepresentation = lazy(() =>
  import('./PageRepresentation').then((m) => ({ default: m.PageRepresentation })),
)
const PagePilotage = lazy(()=>import('./PagePilotage').then((m)=>({default:m.PagePilotage})))
export const routesPilotage: RouteObject[] = [{index:true,element:<PagePilotage/>}]

export const routesDashboards: RouteObject[] = [
  {
    index: true,
    element: <TableauxDeBord />,
  },
  {
    path: SEGMENT_REPRESENTATION,
    element: <PageRepresentation />,
  },
]
